import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { retailerChatbotSettingEnabled } from "@faire/help-center-utils/lib/retailerChatbotSettingEnabled";
import { getIsLoggedInUser } from "@faire/help-center-utils/serialized-data/getUser";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Storage } from "@faire/web--source/common/Storage";
import { useQuery as useJwtAuthQuery } from "@faire/web-api--source/api/help-center/messenger/auth/get-hooks";
import { useQuery as useConversationQuery } from "@faire/web-api--source/api/help-center/messenger/conversation/get-hooks";
import { route as supportSelfServeChatCsat } from "@faire/web-api--source/routes/support/self-serve/chat-csat";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { initChatAndUpdateLocalStorage } from "../chatWidget";
import { FAIRE_CHAT_METADATA } from "../consts";

export const useInitChatOnOngoingConversationEffect = () => {
  const { hasAIChatbotAccess } = useAIChatbotAccess();
  const { data: jwtAuth } = useJwtAuthQuery({
    enabled: getIsLoggedInUser() && !retailerChatbotSettingEnabled(),
  });
  const { data: conversation } = useConversationQuery({
    enabled: getIsLoggedInUser() && !retailerChatbotSettingEnabled(),
  });
  const { pathname } = useLocation();
  const { strictLocalize } = useStrictLocalization();
  useEffect(() => {
    // If the user is on the chat csat page, don't initialize the chat widget
    // This is to prevent chat icon showing up inside the webview from chat widget
    if (pathname === supportSelfServeChatCsat) {
      return;
    }
    if (hasAIChatbotAccess) {
      return;
    }

    if (jwtAuth && conversation) {
      const { is_conversation_started } = conversation;
      if (is_conversation_started) {
        // If the chat is ongoing, keep passing metadata to the chat widget in case the user refreshes the page
        const metaData = Storage.local.getItem(FAIRE_CHAT_METADATA);
        const parsedMetadata = metaData ? JSON.parse(metaData) : {};
        initChatAndUpdateLocalStorage(jwtAuth, strictLocalize, parsedMetadata);
      }
    }
  }, [conversation, hasAIChatbotAccess, jwtAuth, pathname, strictLocalize]);
};
